import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-table-loader',
    templateUrl: './table-loader.component.html',
    styleUrls: ['./table-loader.component.scss'],
    standalone: false
})
export class TableLoaderComponent implements OnInit {
  animation = 'pulse';
  contentLoaded = false;
  count = 2;
  widthHeightSizeInPixels = 50;
  ImageBOx: any = false;
  intervalId: number | null = null;

  @Input() isLoading: any;
  @Input() notFoundData: string | boolean; // Changed to accept string or boolean
  @Input() isTable: any;
  @Input() colspan: any;
  @Input() isWidth: any;

  // Helper to get the display message
  getDisplayMessage(): string {
    if (typeof this.notFoundData === 'string' && this.notFoundData) {
      return this.notFoundData;
    }
    return 'No Data Found '; // Default message for boolean or empty cases
  }

  ngOnInit() {
    setTimeout(() => {
      this.contentLoaded = true;
    }, 2000);

    this.intervalId = window.setInterval(() => {
      this.animation = this.animation === 'pulse' ? 'progress-dark' : 'pulse';
      this.count = this.count === 2 ? 5 : 2;
      this.widthHeightSizeInPixels = this.widthHeightSizeInPixels === 50 ? 100 : 50;
    }, 5000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}